import { render, staticRenderFns } from "./CoinCharts.vue?vue&type=template&id=728a2117"
import script from "./CoinCharts.vue?vue&type=script&lang=js"
export * from "./CoinCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports